<template>
   <v-layout aling-start>
      <v-flex>
         <v-container fluid>
            <v-layout
               wrap
               :style="
                  $vuetify.breakpoint.xlOnly
                     ? 'padding-right: 10%; padding-left: 10%'
                     : ''
               "
            >
               <!-- TÍTULO -->
               <v-flex xs12 text-center mb-8>
                  <span class="font-weight-medium text-h5">
                     {{ subMenu ? subMenu.titulo : 'Aranceles' }}
                  </span>
                  <div class="caption grey--text text--darken-1 mt-2">
                     Seleccione el apartado que desea consultar.
                  </div>
                  <!-- Volver al listado principal cuando se está en un submenú -->
                  <v-btn
                     v-if="subMenu"
                     text
                     small
                     color="primary"
                     class="mt-2"
                     @click="subMenu = null"
                  >
                     <v-icon left small>fas fa-arrow-left</v-icon>
                     Volver
                  </v-btn>
               </v-flex>

               <!-- OPCIONES -->
               <v-flex xs12>
                  <v-container class="px-1" grid-list-md fluid>
                     <v-layout wrap justify-center>
                        <v-flex
                           v-for="opcion in opcionesMostradas"
                           :key="opcion.titulo"
                           xs12
                           sm6
                           :md4="!subMenu"
                           :md5="!!subMenu"
                        >
                           <v-layout align-center justify-center wrap>
                              <!-- BOTON -->
                              <v-flex
                                 xs12
                                 :class="
                                    $vuetify.breakpoint.smAndUp ? 'px-8' : ''
                                 "
                              >
                                 <v-btn
                                    rounded
                                    color="primary"
                                    block
                                    height="60px"
                                    x-large
                                    @click="seleccionar(opcion)"
                                 >
                                    <v-icon left>{{ opcion.icono }}</v-icon>
                                    {{ opcion.titulo }}
                                 </v-btn>
                              </v-flex>

                              <!-- DESCRIPCION -->
                              <v-flex xs12 class="text-center mt-4 mb-8">
                                 <div
                                    class="body-2 grey--text text--darken-1"
                                    style="white-space: pre-wrap"
                                 >
                                    {{ opcion.descripcion }}
                                 </div>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                     </v-layout>
                  </v-container>
               </v-flex>
            </v-layout>
         </v-container>
      </v-flex>
   </v-layout>
</template>

<script>
import { authComputed } from '../helpers'

// Cada apartado con el permiso que lo habilita. Son los mismos permisos que
// antes gobernaban los ítems sueltos del menú lateral.
const OPCIONES = [
   {
      permiso: 15,
      ruta: 'arancel',
      titulo: 'Todos los aranceles',
      icono: 'far fa-list-alt',
      descripcion: 'Catálogo completo de aranceles y sus precios.'
   },
   {
      permiso: 6,
      ruta: 'arancelAlumno',
      titulo: 'Por alumno',
      icono: 'far fa-calendar-minus',
      descripcion: 'Aranceles asignados a un alumno en particular.'
   },
   {
      permiso: 16,
      titulo: 'Por periodos',
      icono: 'far fa-calendar-alt',
      descripcion: 'Aranceles habilitados en cada periodo académico.',
      // En vez de navegar, abre un segundo nivel: los que dependen de fechas y
      // los que están siempre disponibles se administran por separado.
      opciones: [
         {
            ruta: 'arancelPeriodo',
            vista: 'periodos',
            titulo: 'Por periodo',
            icono: 'far fa-calendar-alt',
            descripcion:
               'Aranceles con fecha de inicio y fin, habilitados solo dentro de ese rango.'
         },
         {
            ruta: 'arancelPeriodo',
            vista: 'permanentes',
            titulo: 'Permanentes',
            icono: 'fas fa-infinity',
            descripcion:
               'Aranceles siempre disponibles, sin importar la fecha.'
         }
      ]
   }
]

export default {
   name: 'ArancelesMenu',
   data: () => ({
      // Opción de primer nivel abierta; null es el listado principal.
      subMenu: null
   }),
   computed: {
      ...authComputed,
      // Solo los apartados que el usuario tiene permitidos.
      opcionesVisibles() {
         return OPCIONES.filter((o) => this.puede(o.permiso))
      },
      // Lo que se dibuja: el primer nivel, o las opciones del submenú abierto.
      opcionesMostradas() {
         return this.subMenu ? this.subMenu.opciones : this.opcionesVisibles
      }
   },
   created() {
      // Sin ningún permiso de aranceles no hay nada que mostrar.
      if (!this.opcionesVisibles.length) {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      /**
       * permController lanza TypeError si el usuario no tiene fila para ese
       * controlador, y acá eso tumbaría la pantalla; se degrada a "sin acceso".
       */
      puede(permiso) {
         try {
            return this.permController(permiso, 'ver')
         } catch (e) {
            return false
         }
      },
      /**
       * Una opción con `opciones` abre el segundo nivel en la misma pantalla;
       * el resto navega directo.
       */
      seleccionar(opcion) {
         if (opcion.opciones) {
            this.subMenu = opcion
            return
         }

         this.$router.push({
            name: opcion.ruta,
            // La vista le dice a la pantalla destino qué tabla mostrar. Sin
            // este parámetro se muestran las dos, como antes.
            query: opcion.vista ? { vista: opcion.vista } : undefined
         })
      }
   }
}
</script>

<style scoped>
.colorPrimary {
   color: var(--v-primary-base) !important;
}
</style>
